<template>
    <div class="row no-gutters">
        <div class="col-xl-4">
            <label class="option">
                <span class="option-control">
                    <span class="radio radio-success">
                        <input type="radio"
                               name="product_data_distribution"
                               value="all"
                               :checked="'all' === value"
                               @input="$emit('input', 'all')"
                        >
                        <span></span>
                    </span>
                </span>
                <span class="option-label">
                    <span class="option-head">
                        <span class="option-title">{{ __('brand.distribution.all.title') }}</span>
                        <span v-if="false" class="option-focus" :class="{'text-muted': value !== 'all'}">3 Geschäfte</span>
                    </span>
                    <span class="option-body" :class="{'text-dark': value === 'all'}">
                        {{ __('brand.distribution.all.description') }}
                    </span>
                </span>
            </label>
        </div>
        <div class="col-xl-4 px-0 px-xl-3">
            <label class="option">
                <span class="option-control">
                    <span class="radio radio-warning">
                        <input type="radio"
                               name="product_data_distribution"
                               value="limited"
                               :checked="'limited' === value"
                               @input="$emit('input', 'limited')"
                        >
                        <span></span>
                    </span>
                </span>
                <span class="option-label">
                    <span class="option-head">
                        <span class="option-title">{{ __('brand.distribution.limited.title') }}</span>
                        <span v-if="false" class="option-focus" :class="{'text-muted': value !== 'limited'}">2 Geschäfte</span>
                    </span>
                    <span class="option-body" :class="{'text-dark': value === 'limited'}">
                        {{ __('brand.distribution.limited.description') }}
                    </span>
                </span>
            </label>
        </div>
        <div class="col-xl-4">
            <label class="option">
                <span class="option-control">
                    <span class="radio radio-danger">
                        <input type="radio"
                               name="product_data_distribution"
                               value="none"
                               :checked="'none' === value"
                               @input="$emit('input', 'none')"
                        >
                        <span></span>
                    </span>
                </span>
                <span class="option-label">
                    <span class="option-head">
                        <span class="option-title">{{ __('brand.distribution.disabled.title') }}</span>
                        <span class="option-focus"></span>
                    </span>
                    <span class="option-body" :class="{'text-dark': value === 'none'}">
                        {{ __('brand.distribution.disabled.description') }}
                    </span>
                </span>
            </label>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: String,
        brandUuid: String,
    },
}
</script>
